import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69f1641b63911b001435902b_1788109602384_7920278c/schoolfinder/src/app/not-found.tsx");
